export enum Permission {
  ManageCampaigns = 'MANAGE_CAMPAIGNS',
  ManageClients = 'MANAGE_CLIENTS',
  ManageUsers = 'MANAGE_USERS',
  ManageRequests = 'MANAGE_REQUESTS',
}
